<div class="edit-page">
  <div class="top-line"></div>

  <div class="visitor">
    <button class="close" (click)="close()">
      <img class="cross-icon" src="icons/profile-close.svg" />
    </button>

    <span class="visitor-txt">
      {{ data.title }}
    </span>
  </div>

  <p class="form-header">
    {{ data.message }}

    @if (data.highlightText) {
      <span class="active">
        {{ data.highlightText }}
      </span>
    }
  </p>

  @if (data.showActions) {
    <div class="action-row">
      <button class="ac-secondary-btn" (click)="close()">
        Cancel
      </button>

      <button class="primary-btn" (click)="continue()">
        {{ data.confirmText || 'Continue' }}
      </button>
    </div>
  } @else {
    <div class="action-row">
      <button class="primary-btn" (click)="close()">
        Okay
      </button>
    </div>
  }

  <div class="down-line"></div>
</div>
